import { useQuery } from '@tanstack/react-query';
import { getTeam } from 'api/teams';
import { teamsKeys } from 'api/queryKeys';
import { useMainCompanyQuery } from './useMainCompanyQuery';

export const useTeamQuery = (teamId: string | null) => {
  const { data: mainCompany } = useMainCompanyQuery();
  const companyId = mainCompany?.id ?? '';

  return useQuery({
    queryKey: teamsKeys.detail(companyId, teamId ?? ''),
    queryFn: () => getTeam(teamId!).then((res) => res.data),
    enabled: !!companyId && !!teamId
  });
};
